import {
  GET_DASHBOARD_DATA,
  GET_DASHBOARD_DATA_SUCCESS,
  GET_DASHBOARD_DATA_ERROR,
  GET_DASHBOARD_ACTIVITY_LIST,
  GET_DASHBOARD_ACTIVITY_LIST_SUCCESS,
  GET_DASHBOARD_ACTIVITY_LIST_FAIL,
} from "./actionType";

// Get Dashboard Data
export const getDashboardData = () => ({
  type: GET_DASHBOARD_DATA,
});

export const getDashboardDataSuccess = (response) => ({
  type: GET_DASHBOARD_DATA_SUCCESS,
  payload: response,
});

export const getDashboardDataError = (error) => ({
  type: GET_DASHBOARD_DATA_ERROR,
  payload: error,
});

// Get Dashboard Activity List
export const getDashboardActivityList = () => ({
  type: GET_DASHBOARD_ACTIVITY_LIST,
});

export const getDashboardActivityListSuccess = (response) => ({
  type: GET_DASHBOARD_ACTIVITY_LIST_SUCCESS,
  payload: response,
});

export const getDashboardActivityListFail = (response) => ({
  type: GET_DASHBOARD_ACTIVITY_LIST_FAIL,
  payload: response,
});
